import React from 'react'
import './Description.css'

interface DescriptionProps {
  children: React.ReactNode
}

const Description = ({ children }: DescriptionProps) => {
  return <p className="description">{children}</p>
}

export default Description
